exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload[data-v-50c5cc24]{background:#f4f4f4;width:280px;height:120px;background:#f9f9f9;border-radius:8px;border:1px dashed #bdb9b9}.avatar-uploader .el-upload[data-v-50c5cc24]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-50c5cc24]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-50c5cc24]{font-size:28px;color:#8c939d;width:280px;height:120px;line-height:120px;text-align:center}.avatar[data-v-50c5cc24]{width:280px;height:120px;display:block;border-radius:8px;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
